import { Component } from '@angular/core';

@Component({
    selector: 'app-full-screen-header',
    templateUrl: './full-screen-header.component.html',
    styleUrl: './full-screen-header.component.scss',
    standalone: false
})
export class FullScreenHeaderComponent {

  
}
